import { INSURANCE_TYPES } from '../../../src/client/pages/insurance/constants';
import getStaticPathsForInsuranceTypes from '../utils/get-static-paths-for-insurance-types';
import HelpPage from '../../../src/client/pages/insurance/help';

export const getStaticPaths = () => getStaticPathsForInsuranceTypes([INSURANCE_TYPES.LIFE]);

export const getStaticProps = () => ({
  props: {
    insuranceType: INSURANCE_TYPES.LIFE,
  },
});

export default HelpPage;
